import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

// 응답 데이터 타입
interface BranchProduct {
    branch_product_idx: number;
    branch_product_name: string;
    file_name: string;
    original_name: string;
}

interface BranchProductResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: BranchProduct[];
}

export const useGetBranchProduct = (page: number, searchtxt: string): UseQueryResult<BranchProductResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<BranchProductResponse, Error>({
        queryKey: ["getBranchProduct", page, searchtxt],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_branch_product}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    limit: 10,
                    page,
                    search: "branch_product_name",
                    searchtxt,
                },
            });
            return response.data.data;
        },
    });
};
